/**
 * GoogleAnalyticsInit - Componente de inicialización para Google Analytics
 * Se encarga de verificar el consentimiento al cargar la aplicación
 */

import { useEffect } from 'react';
import GoogleAnalyticsManager from '../utils/GoogleAnalyticsManager';

const GoogleAnalyticsInit = () => {
  useEffect(() => {
    const initializeGA = async () => {
      try {
        console.log('Inicializando verificación de Google Analytics...');
        
        // Configurar GoogleAnalyticsManager para los componentes de la librería
        if (typeof window !== 'undefined' && window.setGoogleAnalyticsManager) {
          window.setGoogleAnalyticsManager(GoogleAnalyticsManager);
        }
        
        // Verificar y actualizar estado de GA basado en consentimiento actual
        await GoogleAnalyticsManager.updateConsentStatus();
        
        // Escuchar cambios en localStorage para consentimiento
        const handleStorageChange = async (event) => {
          if (event.key === 'cookieConsent') {
            console.log('Cambio detectado en consentimiento de cookies');
            await GoogleAnalyticsManager.updateConsentStatus();
          }
        };
        
        window.addEventListener('storage', handleStorageChange);
        
        // Cleanup
        return () => {
          window.removeEventListener('storage', handleStorageChange);
        };
        
      } catch (error) {
        console.error('Error al inicializar Google Analytics:', error);
      }
    };
    
    // Ejecutar inicialización después de que el DOM esté listo
    const timeoutId = setTimeout(initializeGA, 100);
    
    return () => clearTimeout(timeoutId);
  }, []);
  
  // Este componente no renderiza nada
  return null;
};

export default GoogleAnalyticsInit;